module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "visible": _vm.showAdminModal === 'addEditCity',
      "size": "lg",
      "lazy": true
    },
    on: {
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.item) ? _c('h4', [_vm._v("Изменить город " + _vm._s(_vm.item.name))]) : _c('h4', [_vm._v("Добавить город")])]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Сохраняем..."
    }
  }) : _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.name.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "item-name"
    }
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.name),
      expression: "newDataItem.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-name"
    },
    domProps: {
      "value": (_vm.newDataItem.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "name", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.name.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.name.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Название обязательно должно быть указано, минимум " + _vm._s(_vm.$v.newDataItem.name.$params.minLength.min) + " символа")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.newDataItem.sort.$error
    }
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label",
    attrs: {
      "for": "item-sort"
    }
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newDataItem.sort),
      expression: "newDataItem.sort",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "item-sort"
    },
    domProps: {
      "value": (_vm.newDataItem.sort)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDataItem, "sort", $event.target.value.trim())
      }, function($event) {
        _vm.$v.newDataItem.sort.$touch()
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.newDataItem.sort.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Укажите число")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-md-2 col-form-label"
  }, [_vm._v("Активность города")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 col-md-4"
  }, [_c('label', {
    staticClass: "switch switch-lg switch-3d switch-primary ml-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDataItem.enabled),
      expression: "newDataItem.enabled"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newDataItem.enabled) ? _vm._i(_vm.newDataItem.enabled, null) > -1 : (_vm.newDataItem.enabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newDataItem.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newDataItem.enabled = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newDataItem.enabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newDataItem, "enabled", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label"
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  }), _vm._v(" "), (_vm.newDataItem.enabled) ? _c('small', [_vm._v("включен")]) : _c('small', [_vm._v("выключен")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.$v.newDataItem.$invalid
    },
    attrs: {
      "disabled": _vm.$v.newDataItem.$invalid,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.beforeUpdateForm($event)
      }
    }
  }, [(_vm.item) ? [_vm._v("Сохранить изменения")] : [_vm._v("Добавить город")]], 2) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d9e458ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-d9e458ac"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalAdminAddEditCity.vue
// module id = 1074
// module chunks = 1